import { useQuery } from "@tanstack/react-query";
import dealService from "@services/deal.service";
import { DealSourceTypesResponse } from "@app-types/common.type";
import { DEAL_SOURCE_TYPES_QUERY_KEY, QUERY_CACHE_LONG_EXPIRATION_MS } from "@config/query";

export function useDealSourceTypes() {
  const { data, error, isLoading, fetchStatus, refetch } = useQuery<DealSourceTypesResponse>({
    queryKey: [DEAL_SOURCE_TYPES_QUERY_KEY],
    queryFn: async () => await dealService.getDealSourceTypes(),
    staleTime: QUERY_CACHE_LONG_EXPIRATION_MS,
    retry: false,
  });

  return { data, error, isLoading, fetchStatus, refetch };
}
